import { render, staticRenderFns } from "./InternshipResources.vue?vue&type=template&id=520aa72f&"
import script from "./InternshipResources.vue?vue&type=script&lang=js&"
export * from "./InternshipResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports